module.exports = __webpack_public_path__ + "static/media/landing-bg.28f68255.webp";